var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToICloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.762 4C12.6064 4.00242 11.4722 4.32393 10.476 4.9315C9.47975 5.53907 8.65733 6.41081 8.09317 7.4572C7.60758 7.21186 7.07468 7.08398 6.53457 7.08319C5.68803 7.0855 4.86981 7.39973 4.22583 7.96983C3.58185 8.53993 3.15398 9.32884 3.01855 10.1958C2.12434 10.5843 1.36074 11.2383 0.823674 12.0757C0.286613 12.9131 5.30942e-05 13.8965 0 14.9023C0.00126157 16.2552 0.520291 17.5521 1.44297 18.5081C2.36566 19.464 3.61646 20.0007 4.92039 20C5.12674 19.9981 5.33276 19.9827 5.53724 19.9539H19.2089C19.2807 19.9592 19.3526 19.9629 19.4246 19.9647C19.4932 19.9627 19.5617 19.9591 19.6301 19.9539H19.9575V19.9286C21.0707 19.792 22.0971 19.2344 22.8422 18.3615C23.5872 17.4886 23.9992 16.361 24 15.1926V15.1834C23.9974 14.0737 23.6239 12.9996 22.9438 12.146C22.2636 11.2923 21.3194 10.7124 20.2734 10.5061C20.2113 8.75791 19.4979 7.10287 18.2835 5.88937C17.069 4.67587 15.4481 3.99856 13.762 4Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 24.0729,
    y1: 15.2055,
    x2: -0.00918993,
    y2: 14.8854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E82F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93DCF7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToICloud);
export default __webpack_public_path__ + "static/media/toICloud.f50e5272682edfae3a2323b662801dd2.svg";
export { ForwardRef as ReactComponent };